import { makeAutoObservable, runInAction } from "mobx";
import { t, translate } from "../../I18n";
export class POrderSummaryCancelled {
    constructor(params) {
        this.type = "Cancelled";
        this.isFinal = true;
        this.reason = params.reason;
        this.confirmationSource = params.confirmationSource;
        this.isOnlinePayment = params.isOnlinePayment;
        this.restaurantPhones = params.restaurantPhones;
        this.retryOrder = params.retryOrder;
        this.paymentRetryAvailable = params.performPaymentRetry !== null;
        this.retryPaymentError = null;
        this.retryPaymentPending = false;
        if (params.performPaymentRetry !== null &&
            params.onPaymentRetrySuccess !== null) {
            const performPaymentRetry = params.performPaymentRetry;
            const onPaymentRetrySuccess = params.onPaymentRetrySuccess;
            this.retryPayment = async () => {
                console.log("[TYP] Retrying payment...");
                runInAction(() => {
                    this.retryPaymentError = null;
                    this.retryPaymentPending = true;
                });
                const response = await performPaymentRetry();
                runInAction(() => {
                    this.retryPaymentPending = false;
                });
                if (response === null || response.tag === "Errors") {
                    runInAction(() => {
                        this.retryPaymentError =
                            (response === null || response === void 0 ? void 0 : response.tag) === "Errors"
                                ? response.contents.join(", ")
                                : translate(t.orders.checkout.server_error_with_contact, {
                                    phoneNumber: "",
                                }).slice(0, -1) + ".";
                    });
                }
                else {
                    onPaymentRetrySuccess(response);
                }
            };
        }
        else {
            this.retryPayment = null;
        }
        makeAutoObservable(this);
    }
    setPaymentRetryExpired() {
        console.log("[TYP] Payment retry expired – switching to order retry");
        this.paymentRetryAvailable = false;
        console.log("[TYP] Order retry mode active");
    }
}
